import React from "react";
import {Box, Text} from "grommet";
import useSWR from "swr";
import PayoutList from "../../components/pages/payouts/PayoutList";
import {handleErrors, silentFetcher} from "../../utils/errors";
import AppLayout from "../../components/layouts/AppLayout";
import { useRouter } from "next/router";
import PayoutDetails from "../../components/pages/payouts/PayoutDetails";
import UpcomingPayoutList from "../../components/pages/transactions/UpcomingPayoutList";

function Reports(props) {
    const {
        children,
        hidePayout,
        title
    } = props;
    const router = useRouter();
    const { payout_id } = router.query;

    const ReportsMenu = [
        { label: 'Payouts', href: '/reports', regExp: /(\/reports?(\?payout_id=([0-9]+))$)|(\/reports$)/}, // url matches either '/reports' or 'reports?=payout_id=*'
        { label: 'Aging Balance', href: '/reports/aging-balance' },
        { label: 'Product Sales', href: '/reports/product-sales' },
        { label: 'Customer Sales', href: '/reports/customer-sales' },
    ];

    const fetcher = (url) => fetch(url)
        .then(handleErrors)
        .catch(props.showNotification);

    const { data, error } = useSWR('/api/reports/payouts', fetcher, { revalidateOnFocus: false });
    const { data: pendingPayoutTxns, error: pendingPayoutTxnsError } = useSWR('/api/reports/payouts/pending', fetcher, { revalidateOnFocus: false });

    return (
        <AppLayout title={title || "Payouts"} hasStickyDesktopPageHeader>
            {data && !hidePayout &&
                (<Box flex="grow">
                    {(pendingPayoutTxns && pendingPayoutTxns?.total) ?
                        <UpcomingPayoutList
                            data={pendingPayoutTxns}
                        /> : <></>
                    }
                    <PayoutList 
                        title={pendingPayoutTxns && pendingPayoutTxns.total ? "Past" : undefined} payouts={data?.payouts || []} />
                    {payout_id && (
                        <PayoutDetails 
                            id={payout_id} 
                            onClose={() => router.replace('/reports', undefined, { scroll: false })} 
                        />)}
                </Box>)
            }
            {children}
        </AppLayout>
    );
}

export default Reports;
